import React from "react"
import { FormattedMessage } from "react-intl"
// import "./404.css"

const NotFoundSection = ({ message = null }) => {
  return (
    <section>
      <div className="inner inner-404">
        <h1>
          <FormattedMessage id="404-page-not-found" defaultMessage="Page Not Found" />
        </h1>
        <p>
          {message ? (
            message
          ) : (
            <FormattedMessage
              id="404-page-paragraph"
              defaultMessage="Sorry, we can't seem to find the page you're looking for. But we are still determined to help you find your way in life! Stick around to browse stories about careers and people you may not otherwise meet."
            />
          )}
        </p>
      </div>
    </section>
  )
}

export default NotFoundSection
